import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useAuthStore } from "../../stores/auth-store";

interface NavigationItem {
  name: string;
  href: string;
  description?: string;
}

export function Sidebar() {
  const location = useLocation();
  const { user } = useAuthStore();

  // Check if user is super admin
  const isSuperAdmin = user?.role === "SUPER_ADMIN";

  // Base navigation items available to all users
  const baseNavigation: NavigationItem[] = [
    // { name: "Dashboard", href: "/dashboard" },
    {
      name: "Conversations",
      href: "/conversations",
      description: "Build conversations by attaching reusable components",
    },
    {
      name: "Assets",
      href: "/assets",
      description: "Reusable PDFs, images, documents, and URLs",
    },
    {
      name: "Start Messages",
      href: "/message-templates",
      description: "Pre-filled messages for SMS and chat",
    },
    {
      name: "Auto-Responders",
      href: "/auto-responders",
      description: "Reusable message components",
    },
    {
      name: "Destinations",
      href: "/destinations",
      description: "Reusable URL endpoints",
    },
    { name: "Analytics", href: "/analytics" },
  ];

  // Super admin only navigation items
  const superAdminNavigation: NavigationItem[] = [
    {
      name: "Clients",
      href: "/clients",
      description: "Independent client management",
    },
  ];

  // Build final navigation array
  const navigation: NavigationItem[] = [
    ...baseNavigation,
    ...(isSuperAdmin ? superAdminNavigation : []),
    { name: "Settings", href: "/settings" },
  ];

  // Function to check if a navigation item is current
  const isCurrentPath = (href: string) => {
    if (href === "/dashboard") {
      return location.pathname === "/" || location.pathname === "/dashboard";
    }
    return location.pathname.startsWith(href);
  };

  return (
    <div className="w-64 bg-gray-800 shadow-lg border-r border-gray-700">
      <nav className="mt-5 px-2">
        <div className="space-y-1">
          {navigation.map((item) => (
            <Link
              key={item.name}
              to={item.href}
              className={`${
                isCurrentPath(item.href)
                  ? "bg-brand-600 border-brand-500 text-white"
                  : "border-transparent text-gray-300 hover:bg-gray-700 hover:text-white"
              } group flex flex-col px-2 py-2 text-sm font-medium border-l-4 transition-colors duration-200`}
              title={item.description || item.name}
            >
              <span className="font-medium">{item.name}</span>
              {item.description && (
                <span className="text-xs opacity-75 mt-0.5">
                  {item.description}
                </span>
              )}
            </Link>
          ))}
        </div>
      </nav>
    </div>
  );
}
